<div class="navigation-sidebar container" fxLayout="column" [ngClass]="{expanded: !isCollapsed}"
     [ngClass.lt-md]="{expanded: false}">
  <mtn-my-company-widget [condensedMode]="isCollapsed"></mtn-my-company-widget>
  <div class="interactive-button-list" fxLayout="column" fxLayoutGap="5px">
    <div class="divider"></div>
    <mtn-navigation-button icon="cogs" label="{{ 'NAV_LABEL_Administration' | translate }}" path="administration"
                           *ngIf="isAdministrator" [condensedMode]="isCollapsed"></mtn-navigation-button>
    <mtn-navigation-button icon="folders" label="{{ 'NAV_LABEL_Collections' | translate }}" path="collection"
                           [condensedMode]="isCollapsed"></mtn-navigation-button>
    <mtn-navigation-button icon="search-location" label="{{ 'MAP_SEARCH' | translate }}" path="map-search"
                           [condensedMode]="isCollapsed"></mtn-navigation-button>
    <mtn-navigation-button icon="list-ul" label="{{ 'NAV_LABEL_Details' | translate }}" [path]="detailsPath"
                           [isDisabled]="!detailsPath" [condensedMode]="isCollapsed"></mtn-navigation-button>
    <button class="collapse-toggle" mat-mini-fab [fxHide.lt-md]="true" fxLayoutAlign="center center"
            (click)="toggleIsCollapsed()"
            [matTooltip]="isCollapsed ? ('NAV_LABEL_ExpandNavigation' | translate) : ('NAV_LABEL_CollapseNavigation' | translate)"
            matTooltipPosition="right">
      <fa-icon [icon]="isCollapsed ? 'chevron-right' : 'chevron-left'"
               [ngStyle]="{'margin-right': isCollapsed ? '0' : '3px'}"></fa-icon>
    </button>
  </div>
</div>
